
import React, { Component } from "react";
import { withRouter, NavLink } from "react-router-dom";



class Sidebar extends React.Component {
    constructor(props, context) {
        super(props, context)

        this.state = {
            active_link: 'home',
            userinfo: JSON.parse(localStorage.getItem('userinfo'))
        }
    }

    componentDidMount() { }

    goTo(route, menuItem) {
        this.setState({ active_link: menuItem });
        <landing active_link={this.state.active_link} />
    }

    render() {
        let state = this.state

        return (
            <aside class="main-sidebar sidebar-dark-primary elevation-4 mbl-overflow-hide">
                <div class="sidebar p-0">
                    <nav>
                        <div id="accordion">
                            <div class="card left-menu-bar-new mb-0">
                                <div class="card-header">
                                    <a class="card-link" data-toggle="collapse" href="#collapseOne"><b>Reports</b>
                                        <i class="fas fa-chevron-down float-right mt-1"></i>
                                    </a>
                                </div>
                                <div id="collapseOne" class="collapse show" data-parent="#accordion">
                                    <div class="card-body p-0">
                                        {
                                            this.state.userinfo && this.state.userinfo.roleinfo.tasks.indexOf('DCGViewAdminReports') != -1 &&
                                            <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">

                                                <li className={(this.props.tab == 1 ? "nav-item active" : "nav-item")}>
                                                    <a href="/daily-summary" class="nav-link custom-nav-link" id="sketchpad">
                                                        <img src="dist/img/summary.png" class="img-fluid sketchpad_img" />
                                                        <span>Daily Summary</span>
                                                    </a>
                                                </li>                                                
                                                <li className={(this.props.tab == 2 ? "nav-item active" : "nav-item")}>
                                                    <a href="associate-comparison" class="nav-link custom-nav-link">
                                                        <img src="dist/img/associate-icon.png" class="img-fluid" />
                                                        <span>Associate Comparison</span>
                                                    </a>
                                                </li>
                                                <li className={(this.props.tab == 3 ? "nav-item active" : "nav-item")}>
                                                    <a href="store-comparison" class="nav-link custom-nav-link">
                                                        <img src="dist/img/store-comparison-icon.png" class="img-fluid" />
                                                        <span>Store Comparison</span>
                                                    </a>
                                                </li>
                                                <li className={(this.props.tab == 4 ? "nav-item active" : "nav-item")}>
                                                    <a href="market-comparison" class="nav-link custom-nav-link">
                                                        <img src="dist/img/market-comparison.png" class="img-fluid size40" />
                                                        <span>Market Comparison</span>
                                                    </a>
                                                </li>
                                                <li className={(this.props.tab == 7 ? "nav-item active" : "nav-item")}>
                                                    <a href="emailclick-summary" class="nav-link custom-nav-link">
                                                    <i class="fa fa-envelope email-icon" aria-hidden="true" ></i>
                                                        <span>Email Click Summary</span>
                                                    </a>
                                                </li>
                                                <li className={(this.props.tab == 8 ? "nav-item active" : "nav-item")}>
                                                    <a href="status-report" class="nav-link custom-nav-link">
                                                    <img src="dist/img/summary.png" class="img-fluid size40" />
                                                        <span>DCG Customer Status Report</span>
                                                    </a>
                                                </li>                                               
                                                <li className={(this.props.tab == 6 ? "nav-item active" : "nav-item")}>
                                                    <a href="faq-list" class="nav-link custom-nav-link">
                                                        <img src="dist/img/market-comparison.png" class="img-fluid size40" />
                                                        <span>FAQ</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        }

                                    </div>
                                </div>
                            </div>
                            {
                                this.state.userinfo && this.state.userinfo.roleinfo.tasks.indexOf('DCGManageGlobalItems') != -1 &&
                                <div class="card left-menu-bar-new mb-0">
                                    <div class="card-body p-0">
                                        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                                            <li className={(this.props.tab == 5 ? "nav-item active" : "nav-item")}>
                                                <a href="/dcg-questions" class="nav-link custom-nav-link">
                                                    <span>Digital Comfort Guide Questions</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            }
                            {/* <div class="card left-menu-bar-new mb-0">
                            <a class="plane-menus" href="/dcg-questions">
                                <div class="card-header">
                                    Digital Comfort Guide Questions
                                </div>
                            </a>
                        </div> */}
                       </div>

                    </nav>
                </div>
            </aside>


        );
    }
}
export default withRouter(Sidebar);